<div
  class="min-h-screen flex items-center justify-center bg-base-200 px-4 py-12"
>
  <div
    class="daisy-card w-full max-w-lg bg-base-100 shadow-2xl border border-base-300"
  >
    <div class="daisy-card-body items-center text-center p-8">
      <div
        class="w-20 h-20 rounded-full bg-error/10 flex items-center justify-center mb-4"
      >
        <i class="fa-solid fa-triangle-exclamation text-error text-4xl"></i>
      </div>

      <h1 class="text-3xl font-bold text-base-content tracking-tight">
        Workspace Not Found
      </h1>

      <p class="text-base-content/70 mt-3 text-base leading-relaxed">
        @if (workspaceIdentifier && workspaceIdentifier !== 'default') {
          The workspace
          <span
            class="font-semibold text-base-content underline decoration-error/50 underline-offset-2"
            >{{ workspaceIdentifier }}</span
          >
          could not be found. It may have been moved, renamed, or does not
          exist.
        } @else {
          The requested workspace could not be found. It may have been moved,
          renamed, or does not exist.
        }
      </p>

      <div class="daisy-alert daisy-alert-warning mt-6 text-sm text-left">
        <i class="fa-solid fa-circle-info shrink-0 text-base"></i>
        <span
          >Please double-check the URL or contact your academy administrator for
          the correct address.</span
        >
      </div>

      <div
        class="daisy-card-actions mt-8 w-full flex flex-col sm:flex-row gap-3 justify-center"
      >
        <button
          type="button"
          (click)="goToPlatformHome()"
          class="daisy-btn daisy-btn-primary w-full sm:w-auto gap-2"
        >
          <i class="fa-solid fa-house"></i>
          <span>Go to Learnbird Homepage</span>
        </button>
      </div>
    </div>
  </div>
</div>
